import { type AxiosResponse } from 'axios';

import { get, post, put } from '@utilities';

export const fetchAllTickets = async (data: Record<string, any>): Promise<AxiosResponse> => await post(`ticket/all`, data);
